import styled from "styled-components";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import appTheme from "../../themes/Theme";

export const StyledWrapper = styled.div`
  box-sizing: border-box;
  position: fixed;
  height: 60px;
  background-color: ${appTheme.navbarColor};
  color: ${appTheme.textColor};
  padding: 8px 16px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1100;
`;

export const LinkButtonWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ThemeLanguageSwitchWrapper = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
`;

export const StyledExitToAppIcon = styled(ExitToAppIcon)`
  margin: 0 8px;
  cursor: pointer;
`;
